import { firstBy } from "thenby";
import { DateTime } from "luxon";
import { useCallback } from "react";
import { DictionaryEntryType, DictionaryTagEntryType, DictionaryType } from "./types";
import { useDataLayerContext } from "./DataProvider";

export function iterate(dictionary: Array<DictionaryEntryType>, currentIteration: number) {
    let limit = 5;
    if (currentIteration === 3) limit = Math.min(10, dictionary.length);
    if (currentIteration === 6) limit = dictionary.length;
    if (currentIteration > 10) limit = 5;

    let currentRandomIndex = Math.round(limit * Math.random()) - 1;
    if (currentRandomIndex < 0) currentRandomIndex = 0;

    return {
        iteration: currentIteration > 10 ? 0 : currentIteration + 1,
        currentDictionaryEntry: dictionary[currentRandomIndex] || null
    };
}

export function sortDictionary(dictionary: Array<DictionaryEntryType>) {
    return dictionary.sort(firstBy((v1: DictionaryEntryType, v2: DictionaryEntryType) => {
        return (v1?.statistics?.strength || 0) - (v2?.statistics?.strength || 0);
    }).thenBy((v1: DictionaryEntryType, v2: DictionaryEntryType) => DateTime.fromISO(v2.adddate).diff(DateTime.fromISO(v1.adddate)).milliseconds))
}

export function preCollectTags(dataLayer: DictionaryType): Array<DictionaryTagEntryType> {
    const urlParams = new URLSearchParams(window.location.search);
    const tagsParam = urlParams.get('tags');
    let urlTags: string[] = new Array<string>();
    if(tagsParam !== null) urlTags = [...tagsParam.split(',').map(tag => tag.trim())];

    let tagsArray: Array<DictionaryTagEntryType> = dataLayer.tags || [];

    dataLayer.dictionary.forEach(entry => {
        if(!Array.isArray(entry.tags) || entry.tags.length === 0) return;

        entry.tags.forEach(tag => {
            if(tagsArray.find(taEntry => taEntry.tag === tag) === undefined) tagsArray.push({
                tag: tag,
                selected: urlTags.includes(tag)
            })
        });
    });

    return tagsArray.sort(firstBy('tag'));
}

export function useDictinaryFilter() {
    const { dataLayer } = useDataLayerContext();

    return useCallback((dictionary: Array<DictionaryEntryType>) => {
        // console.log('dictionary filtered');
        const selectedTags = (dataLayer.tags || []).filter(tag => tag.selected).map(tag => tag.tag);
        return dictionary.filter((entry: DictionaryEntryType) => {
            if(selectedTags.length === 0) return true;

            for(let i=0; i<selectedTags.length; i++) {
                if(entry.tags.includes(selectedTags[i])) return true;
            }
            return false;
        });
    }, [dataLayer.tags])
}
